import {
  InquiryTemplate,
  InquiryTemplateFilterOption,
  InquiryTemplateStatus,
} from 'dashboard/models/inquiry-template';
import { Template, TemplateFilterOption } from 'dashboard/models/template';
import { VerificationTemplate } from 'dashboard/models/verification-template';
import { ApiModel } from 'lib/interfaces/api';

/**
 * Filters list of templates from which users can create inquiries in dashboard.
 * Used in getAllEnabledTemplates selector. Will be used until we phase out 2.0 templates
 */
export function isCreateEnabledTemplate(template: Template | InquiryTemplate): boolean {
  if (template.type === ApiModel.InquiryTemplate) {
    // Ensure template is active and has published version
    return (
      template.attributes.status === InquiryTemplateStatus.Active &&
      template.relationships['latest-published-version']?.data != null
    );
  } else {
    return template.attributes['allow-create-in-dashboard'];
  }
}

export function isCreateEnabledTemplateBasic(
  basic: TemplateFilterOption | InquiryTemplateFilterOption,
): boolean {
  if (basic.type === ApiModel.InquiryTemplate) {
    // Ensure template is active and has published version
    return basic.status === InquiryTemplateStatus.Active && basic['published-version-id'] != null;
  } else {
    return basic['allow-create-in-dashboard'];
  }
}

export function nameDisplay(
  template: InquiryTemplate | VerificationTemplate | Template | undefined,
): string {
  return template != null
    ? template.type === ApiModel.InquiryTemplate
      ? template.attributes['name-display']
      : template.attributes.name
    : '';
}
